export const _setEpisodeListModule = (state, action) => {
  const { moduleName, show } = action.payload;
  state.episodeListModule = moduleName;
  state.toEpisodeList = show;
};

export const _setIsReferralDataLoaded = (state, action) => {
  state.isReferralDataLoaded = action.payload;
};

export const _setDateReferralSentFromSAP = (state, action) => {
  state.dateReferralSentFromSAP = action.payload;
};

export const _setDateofSAPOrJailRelease = (state, action) => {
  state.dateofSAPOrJailRelease = action.payload;
};

export const _setCountyofParoleId = (state, action) => {
  state.countyofParoleId = action.payload;
};

export const _setDrugTreatmentProgramTransitionCoordinatorId = (
  state,
  action
) => {
  state.drugTreatmentProgramTransitionCoordinatorId = action.payload;
};
export const _setDateReferralSenttoSAP = (state, action) => {
  state.dateReferralSenttoSAP = action.payload;
};
export const _setEpdIcnDateRelExp = (state, action) => {
  state.epdIcnDateRelExp = action.payload;
};

export const _setSTOPPlacementCoordinatorId = (state, action) => {
  state.sTOPPlacementCoordinatorId = action.payload;
};

export const _setClinicalInformationTreatmentRecommendations = (
  state,
  action
) => {
  state.clinicalInformationTreatmentRecommendations = action.payload;
};

export const _setSTOPResponse = (state, action) => {
  state.sTOPResponse = action.payload;
};

export const _setEpdIrydsc = (state, action) => {
  state.epdIrydsc = action.payload;
};
